import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1GlossaryDataRetrieve: build.query<
      ApiPortalV1GlossaryDataRetrieveApiResponse,
      ApiPortalV1GlossaryDataRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/glossary/data/` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1GlossaryDataRetrieveApiResponse = /** status 200  */ {
  /** Unique EDI pillar factors across all survey sets */
  pillars?: {
    id?: string;
    title?: string;
    short_description?: string;
    long_description?: string;
    description?: string;
  }[];
  /** Unique outcome groups across all survey sets */
  outcomes?: {
    id?: string;
    name?: string;
    description?: string;
  }[];
};
export type ApiPortalV1GlossaryDataRetrieveApiArg = void;
export const { useApiPortalV1GlossaryDataRetrieveQuery } = injectedRtkApi;
